import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { ICreateLedger } from "@shared/lib/types/briefCampains";
import { FINANCE_INFLUENCER_QUERY_KEY } from "../contsants";

export function useCreateLedger(campaignInfluencerId: string) {
  const {
    mutate: createLedger,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<ICreateLedger>({
    mutationFn: async (ledger) => {
      return await CampaignService.createLedger(ledger).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    createLedger,
    isCreating,
    isCreated,
  };
}
